import { Component, Input, OnInit } from '@angular/core';
import { Indicator, RecessionData } from './indicator';
import {
  AnalyticsService,
  ModalService,
  SimpleModalConfig,
} from '@frk/eds-components';

const TRACKING_DATA_LAYER = {
  name: 'recession_dashboard',
  event: 'quiz_engagement',
  action: 'indicator_slide',
};

@Component({
  selector: 'aor-indicator',
  templateUrl: './indicator.component.html',
  styleUrls: ['./indicator.component.scss'],
})
export class IndicatorComponent implements OnInit {
  @Input() recessionData: RecessionData;
  cache: string;

  // not my preferred way of doing this... refactor?
  tooltipTitle: string;
  tooltipBody: string;

  @Input() brLabels: object = {};

  constructor(
    private modalService: ModalService,
    private analytics: AnalyticsService
  ) {}

  update(event: Indicator): void {
    this.analytics.trackEvent({
      ...TRACKING_DATA_LAYER,
      label: event.name,
      link_text: event.data.ticks[event.data.value - 1],
    });

    let x = 0;
    const keys = Object.keys(this.recessionData);

    for (let i = 1; i < keys.length; i++) {
      for (x = 0; x < this.recessionData[keys[i]].length; x++) {
        if (this.recessionData[keys[i]][x] === event) {
          this.recessionData[keys[i]][x].data.value = event.data.value;
          this.recessionData = Object.assign({}, this.recessionData);
          return;
        }
      }
    }
  }

  resetRecessionData(): void {
    this.recessionData = Object.assign({}, JSON.parse(this.cache));
  }

  isModified(): boolean {
    return JSON.stringify(this.recessionData) !== this.cache;
  }

  showPopup(indicator: Indicator): void {
    this.tooltipBody = indicator.tooltip;
    this.tooltipTitle = indicator.data.label;

    const config: SimpleModalConfig = {
      id: 'aor-tooltip',
      closeBtnLabel: 'Close',
      title: indicator.data.label,
      type: 'simple',
      // body: indicator.tooltip, - this method is better but isnt working
      themeTitle: 'dark',
      preTitle: '',
    };
    this.modalService.open('aor-tooltip', config);
  }

  ngOnInit(): void {
    if (typeof this.recessionData !== 'undefined') {
      this.cache = JSON.stringify(this.recessionData);
    }
  }
}
